<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'SocialRespCenter', to: { path: '/socialresp-center' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>社會責任</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toSocialRespCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增社會責任</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <SocialRespCenterTable></SocialRespCenterTable>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SocialRespCenterTable from '@/views/B-11__SOCIALRESP/c/SocialRespCenterTable.vue';

export default {
  components: {
    Breadscrumbs,
    SocialRespCenterTable,
  },
  created() {
    this.clear();
    this.getSocialRespList();
  },
  computed: {
    ...mapState('pageTitle', ['pageTitle']),
  },
  methods: {
    ...mapActions('socialresponsibility', {
      getSocialRespList: 'find',
      clear: 'clear',
    }),
    toSocialRespCreate() {
      this.$router.push('/socialresp-center/create');
    },
  },
};
</script>

<style></style>
